// path/to/store/payment-settings/payment-settings.reducer.ts
import { createReducer, on } from '@ngrx/store';
import * as PaymentSettingsActions from './payment-settings.actions';
import { IPaymentSettings } from './payment-settings.actions';

export interface PaymentSettingsState {
  paymentSettings: IPaymentSettings[];
  paymentSettingsCurrent: IPaymentSettings;
  error: any;
  isLoading: boolean
}

export const initialPaymentSettingsState: PaymentSettingsState = {
  paymentSettings: [],
  paymentSettingsCurrent: null as any,
  error: null,
  isLoading: false
};

export const paymentSettingsReducer = createReducer(
  initialPaymentSettingsState,

  on(
    PaymentSettingsActions.loadPaymentSettingsSuccess,
    (state, { paymentSettings }) => ({
      ...state,
      paymentSettings,
      error: null,
    })
  ),
  on(PaymentSettingsActions.loadPaymentSettingsCurrent, (state) => ({
    ...state,
    isLoading: true
  })),
  on(
    PaymentSettingsActions.loadPaymentSettingsCurrentSuccess,
    (state, { paymentSettings }) => ({
      ...state,
      paymentSettingsCurrent: { ...paymentSettings },
      error: null,
      isLoading: false
    })
  ),

  on(PaymentSettingsActions.loadPaymentSettingsFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  on(
    PaymentSettingsActions.savePaymentSettingsSuccess,
    (state, { paymentSettings }) => ({
      ...state,
      paymentSettings: [...state.paymentSettings, paymentSettings],
      error: null,
    })
  ),

  on(PaymentSettingsActions.savePaymentSettingsFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  on(
    PaymentSettingsActions.updatePaymentSettingsSuccess,
    (state, { paymentSettings }) => ({
      ...state,
      paymentSettings: state.paymentSettings.map((item) =>
        item.id === paymentSettings.id ? { ...item, ...paymentSettings } : item
      ),
      error: null,
    })
  ),

  on(
    PaymentSettingsActions.updatePaymentSettingsFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  ),

  on(PaymentSettingsActions.deletePaymentSettingsSuccess, (state, { id }) => ({
    ...state,
    paymentSettings: state.paymentSettings.filter((item) => item.id !== id),
    error: null,
  })),

  on(
    PaymentSettingsActions.deletePaymentSettingsFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);
